import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {loadMeAction} from '../../../reducers/user';
import {loadCountsForSidenavAction} from '../../../reducers/analytics';

import Header from '../../../Components/Widget/Header';
import UIKit from '../../../Components/UIKit';
import BrandFormStyle from '../../../Components/Widget/Brand/FormStyle';

const Edit = ({match}) => {
  const dispatch = useDispatch();
  const {loadMeLoading, loadMeDone} = useSelector(state => state.user);
  const [paramId, setParamId] = useState('');

  useEffect(() => {
    dispatch(loadMeAction());
    dispatch(loadCountsForSidenavAction());
  }, [dispatch]);

  useEffect(() => {
    const {
      params: {id},
    } = match;

    if (id) {
      setParamId(id);
    }
  }, [match]);

  return loadMeLoading
    ? null
    : loadMeDone && (
        <div>
          <UIKit.Div classOptions={'uk-width-1-1'}>
            <Header title={'브랜드 편집 및 추가'} />
          </UIKit.Div>
          <UIKit.Grid>
            <UIKit.Div classOptions={'uk-width-1-1'}>
              <BrandFormStyle paramId={paramId} />
            </UIKit.Div>
          </UIKit.Grid>
        </div>
      );
};

export default Edit;
